<script setup>
import { utils } from '@shop/frontend/web/js/utils';
import { ref } from 'vue';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';

translator.getLanguages();

const isCookieNotificationShow = ref(!utils.getCookie('isCookieAccepted'));

function closeCookieModal() {
  utils.setCookie('isCookieAccepted', 'true', { expires: 30 * 24 * 60 * 60, path: '/' });
  isCookieNotificationShow.value = false;
}
</script>

<template>
  <transition name="slide-out-bottom">
    <div v-if="isCookieNotificationShow" class="cookie-dialog">
      <div class="cookie-dialog__wrapper">
        <p class="cookie-dialog__text">
          {{
            translator.t(
              'main',
              'By using this website, you consent to the use of cookies that help us make it more convenient for you'
            )
          }}
        </p>
        <button class="cookie-dialog__btn btn" @click="closeCookieModal">
          {{ translator.t('main', 'Good') }}
        </button>
        <button class="cookie-dialog__close" @click="isCookieNotificationShow = false">
          <svg class="icon cookie-dialog__close-icon">
            <use xlink:href="#close" />
          </svg>
        </button>
      </div>
    </div>
  </transition>
</template>

<style lang="scss">
@import "@shop/../frontend/web/src/styles/utils/variables.scss";

.cookie-dialog {
  position: fixed;
  display: flex;
  justify-content: center;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background-color: $secondary;
  width: 100%;

  &__wrapper {
    position: relative;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 13px 40px;
  }

  &__cookie-icon {
    width: 65px;
    height: 46px;
  }

  &__btn {
    padding: 9.5px 24px;
    font-size: 16px;
    font-weight: 700;
    background-color: $cookie-primary-color;
    border-radius: 8px;
    text-transform: uppercase;
  }

  &__close {
    position: absolute;
    top: 2px;
    right: -240px;
    padding: 4px;
    color: $cookie-primary-color;
    cursor: pointer;
    background: none;
    border: 0;
  }

  &__close-icon {
    width: 16px;
    height: 16px;
    color: $black;
  }

  &__text {
    margin: 0;
    max-width: 500px;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: $dark-text;
  }

  @media (max-width: $screen-xs) {
    bottom: 0;
    padding: 0;

    &__wrapper {
      padding: 32px 20px 24px;
      flex-direction: column;
      gap: 12px;
    }

    &__text {
      max-width: none;
      text-align: center;
    }

    &__close {
      top: 8px;
      right: 8px;
    }
  }
}

.left-cookie {
  fill: $cookie-left-color;
}

.right-cookie {
  fill: $cookie-right-color;
}
</style>
